import { useEffect, useState } from 'react';

import { getCompanies } from '../services/companiesService';
import { CompaniesSearchParams, Company } from '../types';

export const useCompanies = (searchParams?: CompaniesSearchParams) => {
  const [companies, setCompanies] = useState<Company[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCompanies = async (params?: CompaniesSearchParams) => {
    try {
      setLoading(true);
      setError(null);
      const data = await getCompanies(params);
      setCompanies(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao buscar companies');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanies(searchParams);
  }, [searchParams?.name]);

  const refetch = () => fetchCompanies(searchParams);

  return {
    companies,
    loading,
    error,
    refetch,
  };
};
